import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Aboutcard from "../Civic/AboutCard";
import laptopImg from "../../Assets/inge.png";
import Toolstack from "../Civic/Toolstack";

function Civic() {
  return (
    <>
      {" "}
      <Particle />
      <Container fluid className="about-section">
        <Container>
          <Row style={{ justifyContent: "center", padding: "10px" }}>
            <Col
              md={7}
              style={{
                justifyContent: "center",
                paddingTop: "30px",
                paddingBottom: "50px",
              }}
            >
              <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
                My Civic <strong className="purple">Engagement</strong> journey
              </h1>
              <Aboutcard />
            </Col>
            <Col
              md={5}
              style={{ paddingTop: "120px", paddingBottom: "50px" }}
              className="about-img"
            >
              <img src={laptopImg} alt="about" className="img-fluid" />
            </Col>
          </Row>
          <h1 className="project-heading">
            <strong className="purple">Tools</strong> I use to fulfill my responsibilities
          </h1>
          <Toolstack />

        </Container>
      </Container>
    </>
  );
}

export default Civic;
